import CONSTANTS from 'tradera-apps/tradera/components/discover/constants/constants';

const normalizeFilters = filters => {
    if (filters) {
        let normalized = {};
        filters.map(filter => {
            const { parameter } = filter;
            normalized = {
                ...normalized,
                [parameter]: {
                    ...filter
                }
            };
        });
        return normalized;
    }
};

const activeFilters = filters => {
    if (filters) {
        let normalized = [];
        filters.map(filter => {
            const { selectedValue } = filter;
            if (CONSTANTS.ACTIVE_FILTER_STATES.includes(selectedValue)) {
                normalized.push(filter);
            }
        });
        return normalized;
    }
};

const normalize = responseData => {
    const normalized = {
        activeBrands: [],
        activeFilters: [],
        attributeFilters: [],
        categoryPath: responseData.categoryPath || [],
        currentCategoryId: responseData.categoryPath?.[0]?.id || 0,
        fallbackItemsById: [],
        filterCategories: {},
        filterPrice: {},
        filters: {},
        headerText: responseData.headerText || null,
        internalSearch: responseData.internalSearchBar || {},
        introText: responseData.introText || null,
        itemsById: [],
        itemsOnDisplayById: [],
        mainText: responseData.mainText || null,
        pagination: responseData.pagination || null,
        fallbackUrl: responseData.fallbackUrl || null,
        totalItems: responseData.totalItems || 0,
        discoverTranslationResult: responseData.discoverTranslationResult || {}
    };

    if (responseData.filters) {
        normalized.filterCategories = responseData.filters.categoryFilter;
        normalized.filters = normalizeFilters(
            responseData.filters.singleOptionFilters
        );
        normalized.activeFilters = activeFilters(
            responseData.filters.singleOptionFilters
        );
        normalized.filterPrice = responseData.filters.priceRangeFilter;
        normalized.attributeFilters = responseData.filters.attributeFilters;
    }

    if (responseData.items) {
        responseData.items.map(item => {
            normalized.itemsById.push(item.itemId);
        });
    }

    if (responseData.itemsOnDisplay) {
        responseData.itemsOnDisplay.items.map(item => {
            normalized.itemsOnDisplayById.push(item.itemId);
        });
    }

    if (responseData.fallbackItems) {
        responseData.fallbackItems.map(item => {
            normalized.fallbackItemsById.push(item.itemId);
        });
    }

    normalized.status = responseData.status;
    return normalized;
};

export { normalize };
